import { useMutation } from '@tanstack/react-query';
import { createCheckupFromExistingCheckup } from '../lib/api';

// useCreateCheckupFromExistingCheckup is a hook that creates a new checkup mirroring an existing one, given the existing
// checkup's id. Used by the "upload another video" flow on the checkup complete page.
export const useCreateCheckupFromExistingCheckup = () => {
  const {
    mutateAsync: createCheckup,
    isPending,
    error
  } = useMutation({
    mutationFn: async (completedCheckupId: string) => {
      return createCheckupFromExistingCheckup(completedCheckupId);
    }
  });

  return {
    createCheckup,
    isPending,
    error
  };
};
